module.exports = __webpack_public_path__ + "img/motsu.285faa30.jpg";